export const TWITCH_CLIENT_ID = 'iscuhj0tftkxkrcmwcw4slvjj4k9m3';
export const SESSION_SECRET = 'vLIBBQBcL5E2Tg72ki4SjKmSXWmIi6QV';
export const REDIRECT = (window.location.hostname === 'localhost') ? 'http://localhost:3000/twitchclips/' : window.location.href.split('#')[0];